var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntre({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_5943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_473_5943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.374 14.375L13.624 14.375M29.374 28.625L13.624 28.625M17.999 23.875H24.999C25.8144 23.875 26.2221 23.875 26.5437 23.7545C26.9725 23.5938 27.3132 23.2855 27.4908 22.8976C27.624 22.6066 27.624 22.2378 27.624 21.5C27.624 20.7622 27.624 20.3934 27.4908 20.1024C27.3132 19.7145 26.9725 19.4062 26.5437 19.2455C26.2221 19.125 25.8144 19.125 24.999 19.125H17.999C17.1836 19.125 16.7759 19.125 16.4543 19.2455C16.0255 19.4062 15.6848 19.7145 15.5072 20.1024C15.374 20.3934 15.374 20.7622 15.374 21.5C15.374 22.2378 15.374 22.6066 15.5072 22.8976C15.6848 23.2855 16.0255 23.5938 16.4543 23.7545C16.7759 23.875 17.1836 23.875 17.999 23.875Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_5943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_473_5943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 21,
    fill: "white",
    transform: "matrix(0 -1 1 0 10.999 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntre);
export default __webpack_public_path__ + "static/media/Entre.bf2c7081e60e0fc765026d30640c1a95.svg";
export { ForwardRef as ReactComponent };